import { defineMessages } from 'react-intl';

export const rolesMessages = defineMessages({
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    role: {
        id: 'role',
        defaultMessage: 'Role',
    },
    roles: {
        id: 'roles',
        defaultMessage: 'Roles',
    },
    editRole: {
        id: 'edit-role',
        defaultMessage: 'Edit role',
    },
    addRole: {
        id: 'add-role',
        defaultMessage: 'Add role',
    },
    addRoleSubtitle: {
        id: 'add-role-subtitle',
        defaultMessage: 'Add new role',
    },
    editRoleSubtitle: {
        id: 'edit-role-subtitle',
        defaultMessage: 'Edit role {entry}',
    },
    deleteRoleSubtitle: {
        id: 'delete-role-subtitle',
        defaultMessage: 'Permanently delete role {entry}',
    },
    confirmDeleteRole: {
        id: 'confirm-delete-role',
        defaultMessage: 'Are you sure you want to delete role {entry}? This action cannot be undone.',
    },
    createRoleSuccessDescription: {
        id: 'create-role-success-description',
        defaultMessage: 'Role {entry} has been successfully created.',
    },
    updateRoleSuccessDescription: {
        id: 'update-role-success-description',
        defaultMessage: 'Role {entry} has been successfully updated.',
    },
    deleteRoleSuccessDescription: {
        id: 'delete-role-success-description',
        defaultMessage: 'Role {entry} has been successfully deleted.',
    },
    createRoleSuccess: {
        id: 'create-role-success',
        defaultMessage: 'Role created',
    },
    updateRoleSuccess: {
        id: 'update-role-success',
        defaultMessage: 'Role updated',
    },
    deleteRoleSuccess: {
        id: 'delete-role-success',
        defaultMessage: 'Role deleted',
    },
    dashboard: {
        id: 'dashboard',
        defaultMessage: 'Dashboard',
    },
    accessEntities: {
        id: 'access-entities',
        defaultMessage: 'Access entities',
    },
    manageEntities: {
        id: 'manage-entities',
        defaultMessage: 'Manage entities',
    },
    accessServiceProviders: {
        id: 'access-service-providers',
        defaultMessage: 'Access organisations',
    },
    manageServiceProviders: {
        id: 'manage-service-providers',
        defaultMessage: 'Manage organisations',
    },
    manageSites: {
        id: 'manage-sites',
        defaultMessage: 'Manage sites',
    },
    accessSites: {
        id: 'access-sites',
        defaultMessage: 'Access sites',
    },
    accessAllZones: {
        id: 'access-all-zones',
        defaultMessage: 'Access record from all zones',
    },
    manageZones: {
        id: 'manage-zones',
        defaultMessage: 'Manage zones',
    },
    accessZones: {
        id: 'access-zones',
        defaultMessage: 'Access zones',
    },
    accessGateways: {
        id: 'access-gateways',
        defaultMessage: 'Access gateways',
    },
    manageGateways: {
        id: 'manage-gateways',
        defaultMessage: 'Manage gateways',
    },
    accessSpaces: {
        id: 'access-spaces',
        defaultMessage: 'Access spaces',
    },
    manageSpaces: {
        id: 'manage-spaces',
        defaultMessage: 'Manage spaces',
    },
    manageRoles: {
        id: 'manage-roles',
        defaultMessage: 'Manage roles',
    },
    accessUsers: {
        id: 'access-users',
        defaultMessage: 'Access users',
    },
    manageUsers: {
        id: 'manage-users',
        defaultMessage: 'Manage users',
    },
    manageSystemSettings: {
        id: 'manage-system-settings',
        defaultMessage: 'Manage system settings',
    },
    manageSystemComponents: {
        id: 'manage-system-components',
        defaultMessage: 'Manage system components',
    },
    accessMemberships: {
        id: 'access-memberships',
        defaultMessage: 'Access memberships',
    },
    manageMemberships: {
        id: 'manage-memberships',
        defaultMessage: 'Manage memberships',
    },
    manageMembershipTypes: {
        id: 'manage-membership-types',
        defaultMessage: 'Manage templates',
    },
    accessMembershipTypes: {
        id: 'access-membership-types',
        defaultMessage: 'Access templates',
    },
    accessGatewayPasses: {
        id: 'access-gateway-passes',
        defaultMessage: 'Access gateway passes',
    },
    accessVisitors: {
        id: 'access-visitors',
        defaultMessage: 'Access visitors and their identifiers',
    },
    accessAccessKeys: {
        id: 'access-access-keys',
        defaultMessage: 'Access access keys',
    },
    manageAccessKeys: {
        id: 'manage-access-keys',
        defaultMessage: 'Manage access keys',
    },
    entities: {
        id: 'entities',
        defaultMessage: 'Entities',
    },
    sites: {
        id: 'sites',
        defaultMessage: 'Sites',
    },
    users: {
        id: 'users',
        defaultMessage: 'Users',
    },
    system: {
        id: 'system',
        defaultMessage: 'System',
    },
    memberships: {
        id: 'memberships',
        defaultMessage: 'Memberships',
    },
    visitors: {
        id: 'visitors',
        defaultMessage: 'Visitors',
    },
    saveChanges: {
        id: 'save-changes',
        defaultMessage: 'Save changes',
    },
    rolePermissionsChangesSuccess: {
        id: 'role-permissions-changes-success',
        defaultMessage: 'The permissions for role {entry} were successfully changed',
    },
    rolePermissionsChanged: {
        id: 'role-permissions-changed',
        defaultMessage: 'Role permissions changed',
    },
    backToAllRoles: {
        id: 'back-to-all-roles',
        defaultMessage: 'Back to all roles',
    },
    accessPricingPlans: {
        id: 'access-pricing-plans',
        defaultMessage: 'Access pricing plans',
    },
    managePricingPlans: {
        id: 'manage-pricing-plans',
        defaultMessage: 'Manage pricing plans',
    },
    pricingPlans: {
        id: 'pricing-plans',
        defaultMessage: 'Pricing plans',
    },
    accessRoles: {
        id: 'access-roles',
        defaultMessage: 'Access roles',
    },
    accessKeys: {
        id: 'access-keys',
        defaultMessage: 'Access keys',
    },
    accessTroubleshooting: {
        id: 'access-troubleshooting',
        defaultMessage: 'Access troubleshooting',
    },
    troubleshooting: {
        id: 'troubleshooting',
        defaultMessage: 'Troubleshooting',
    },
    accessBillingEntities: {
        id: 'access-billing-entities',
        defaultMessage: 'Access billing entities',
    },
    manageBillingEntities: {
        id: 'manage-billing-entities',
        defaultMessage: 'Manage billing entities',
    },
    billingEntities: {
        id: 'billing-entities',
        defaultMessage: 'Billing entities',
    },
    accessWhiteLists: {
        id: 'access-white-lists',
        defaultMessage: 'Access white lists',
    },
    manageWhiteLists: {
        id: 'manage-white-lists',
        defaultMessage: 'Manage white lists',
    },
    whiteLists: {
        id: 'white-lists',
        defaultMessage: 'White lists',
    },
    allowValidations: {
        id: 'allow-validations',
        defaultMessage: 'Allow validations',
    },
    manageValidations: {
        id: 'manage-validations',
        defaultMessage: 'Access and manage validations accounts and types',
    },
    validations: {
        id: 'validations',
        defaultMessage: 'Validations',
    },
    homeStats: {
        id: 'home-stats',
        defaultMessage: 'Home stats',
    },
    accessHomeStats: {
        id: 'access-home-stats',
        defaultMessage: 'Access home stats',
    },
    accessGatewaysMonitoring: {
        id: 'access-gateways-monitoring',
        defaultMessage: 'Access gateways monitoring',
    },
    accessGatewaysMonitoringActions: {
        id: 'access-gateways-monitoring-actions',
        defaultMessage: 'Access gateways monitoring actions',
    },
    accessPayStationsMonitoring: {
        id: 'access-pay-stations-monitoring',
        defaultMessage: 'Access pay stations monitoring',
    },
    accessDevicesMonitoring: {
        id: 'access-devices-monitoring',
        defaultMessage: 'Access devices monitoring',
    },
    monitoring: {
        id: 'monitoring',
        defaultMessage: 'Monitoring',
    },
    accessPaymentStatistics: {
        id: 'access-payment-statistics',
        defaultMessage: 'Access payment statistics',
    },
    accessOccupancyStatistics: {
        id: 'access-occupancy-statistics',
        defaultMessage: 'Access occupancy statistics',
    },
    accessValidationStatistics: {
        id: 'access-validation-statistics',
        defaultMessage: 'Access validation statistics',
    },
    statistics: {
        id: 'statistics',
        defaultMessage: 'Statistics',
    },
    accessPayments: {
        id: 'access-payments',
        defaultMessage: 'Access payments',
    },
    accessPayStations: {
        id: 'access-pay-stations',
        defaultMessage: 'Access pay stations',
    },
    managePayStations: {
        id: 'manage-pay-stations',
        defaultMessage: 'Manage pay stations',
    },
    accessPayStationOperations: {
        id: 'access-pay-station-operations',
        defaultMessage: 'Access pay station operations',
    },
    accessPayStationEvents: {
        id: 'access-pay-station-events',
        defaultMessage: 'Access pay station events',
    },
    payments: {
        id: 'payments',
        defaultMessage: 'Payments',
    },
    accessPricingPlanTickRate: {
        id: 'access-pricing-plan-tick-rate',
        defaultMessage: 'Access pricing plans tick rate',
    },
    managePricingPlanTickRate: {
        id: 'manage-pricing-plan-tick-rate',
        defaultMessage: 'Manage pricing plans tick rate',
    },
    accessPricingPlanTiers: {
        id: 'access-pricing-plan-tiers',
        defaultMessage: 'Access pricing plans tiers',
    },
    managePricingPlanTiers: {
        id: 'manage-pricing-plan-tiers',
        defaultMessage: 'Manage pricing plans tiers',
    },
    accessPricingPlanCaps: {
        id: 'access-pricing-plan-caps',
        defaultMessage: 'Access pricing plans caps',
    },
    managePricingPlanCaps: {
        id: 'manage-pricing-plan-caps',
        defaultMessage: 'Manage pricing plans caps',
    },
    accessPricingPlanPeriodAdjustments: {
        id: 'access-pricing-plan-period-adjustments',
        defaultMessage: 'Access pricing plan period adjustments',
    },
    managePricingPlanPeriodAdjustments: {
        id: 'manage-pricing-plan-period-adjustments',
        defaultMessage: 'Manage pricing plans period adjustments',
    },
    accessActiveStays: {
        id: 'access-active-stays',
        defaultMessage: 'Access active stays',
    },
    accessPastStays: {
        id: 'access-past-stays',
        defaultMessage: 'Access past stays',
    },
    accessEventLog: {
        id: 'access-event-log',
        defaultMessage: 'Access event log',
    },
    accessValidation: {
        id: 'access-validation',
        defaultMessage: 'Access validation',
    },
    deleteRoleError: {
        id: 'custom-error:role_deletion_error',
        defaultMessage: 'Role cannot be deleted because it is referenced in other records!',
    },
});
